import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

interface Props {
  message?: string;
};

const LoadingComponent:React.FC<Props> = ({message = 'Loading...'}) => {
  return (
    <Backdrop open={true} invisible={true}>
      <Box display='flex' justifyContent='center' alignItems='center' height='100vh'>
        <CircularProgress size={100} sx={{ color: '#00BFD3' }} />
          <Typography variant='h4' sx={{justifyContent: 'center', position: 'fixed', top: '60%'}}>{message}</Typography>
      </Box>
    </Backdrop>
  )
}

export default LoadingComponent;
